import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import GlobalContext from 'hooks/contexts/GlobalContext';
import HeroWithForm from 'components/sections/heros/heroWithForm/HeroWithForm';
import HeroDefault from './heroDefault/HeroDefault';
import HeroShort from './heroShort/HeroShort';

export const HERO_TYPES = {
  default: HeroDefault,
  withFormWizard: HeroWithForm,
  short: HeroShort,
};

export default function Hero({ heroType, ...props }) {
  const HeroComponent = HERO_TYPES[heroType];
  const heroRef = useRef(null);
  const { actions } = useContext(GlobalContext);

  useEffect(() => {
    if (heroRef) {
      actions.updateGlobalRefs({ heroRef });
    }
    return () => {
      actions.updateGlobalRefs({ heroRef: null });
    };
  }, [heroRef.current]);

  if (!HeroComponent) {
    return <div>{`NO HERO COMPONENT MAPPED YET FOR ${heroType}`}</div>;
  }

  return <HeroComponent {...props} heroRef={heroRef} />;
}

Hero.propTypes = {
  heroType: PropTypes.string.isRequired,
};
